import { CALL_API } from 'middlewares/api';
import fetchData from 'utils/api';
import { url } from 'configs/';
const {
  NEWTUBE_API_SERVER,
} = url;

const FETCH_NEWSCATEGORY_REQUEST = 'tube/companynews/FETCH_NEWSCATEGORY_REQUEST';
const FETCH_NEWSCATEGORY_SUCCESS = 'tube/companynews/FETCH_NEWSCATEGORY_SUCCESS';
const FETCH_NEWSCATEGORY_FAILURE = 'tube/companynews/FETCH_NEWSCATEGORY_FAILURE';
const FETCH_NEWSLIST_REQUEST = 'tube/companynews/FETCH_NEWSLIST_REQUEST';
const FETCH_NEWSLIST_SUCCESS = 'tube/companynews/FETCH_NEWSLIST_SUCCESS';
const FETCH_NEWSLIST_FAILURE = 'tube/companynews/FETCH_NEWSLIST_FAILURE';
const FETCH_NEWS_REQUEST = 'tube/companynews/FETCH_NEWS_REQUEST';
const FETCH_NEWS_SUCCESS = 'tube/companynews/FETCH_NEWS_SUCCESS';
const FETCH_NEWS_FAILURE = 'tube/companynews/FETCH_NEWS_FAILURE';
const FETCH_MYDATDBASIC_REQUEST = 'tube/companynews/FETCH_MYDATDBASIC_REQUEST';
const FETCH_MYDATDBASIC_SUCCESS = 'tube/companynews/FETCH_MYDATDBASIC_SUCCESS';
const FETCH_MYDATDBASIC_FAILURE = 'tube/companynews/FETCH_MYDATDBASIC_FAILURE';
const FETCH_ENROLLMENTLIST_REQUEST = 'tube/companynews/FETCH_ENROLLMENTLIST_REQUEST';
const FETCH_ENROLLMENTLIST_SUCCESS = 'tube/companynews/FETCH_ENROLLMENTLIST_SUCCESS';
const FETCH_ENROLLMENTLIST_FAILURE = 'tube/companynews/FETCH_ENROLLMENTLIST_FAILURE';
const PUT_ENROLLMENTLIST_REQUEST = 'tube/companynews/PUT_ENROLLMENTLIST_REQUEST';
const PUT_ENROLLMENTLIST_SUCCESS = 'tube/companynews/PUT_ENROLLMENTLIST_SUCCESS';
const PUT_ENROLLMENTLIST_FAILURE = 'tube/companynews/PUT_ENROLLMENTLIST_FAILURE';
const DELETE_ENROLLMENTLIST_REQUEST = 'tube/companynews/DELETE_ENROLLMENTLIST_REQUEST';
const DELETE_ENROLLMENTLIST_SUCCESS = 'tube/companynews/DELETE_ENROLLMENTLIST_SUCCESS';
const DELETE_ENROLLMENTLIST_FAILURE = 'tube/companynews/DELETE_ENROLLMENTLIST_FAILURE';

export default function reducer(state = {
  newsCategoryList: [],
  newsList: [],
  news: {},
  myData: {}, // 登入者
  enrollList: [], // 報名者列表
  error: {},
  meta: {}, // 分頁資訊
  isGridFetching: false,
  isFetching: false,
}, action) {
  switch (action.type) {
    case FETCH_NEWSCATEGORY_SUCCESS:
      {
        const httpStatusCode = Number(action.response.meta.httpStatusCode);
        let list = [];
        if (httpStatusCode === 200 && action.response.hasOwnProperty('data')) {
          list = action.response.data;
        }
        return Object.assign({}, state, {
          newsCategoryList: list,
        });
      }
    case FETCH_NEWSCATEGORY_FAILURE:
    case FETCH_NEWSLIST_FAILURE:
      {
        return Object.assign({}, state, {
          error: action.error,
          isGridFetching: false,
        });
      }
    case FETCH_NEWSLIST_REQUEST:
      {
        return Object.assign({}, state, { isGridFetching: true });
      }
    case FETCH_NEWSLIST_SUCCESS:
      {
        const httpStatusCode = Number(action.response.meta.httpStatusCode);
        let list = [];
        let meta = {};
        if (httpStatusCode === 200 && action.response.hasOwnProperty('data')) {
          list = action.response.data;
          meta = action.response.meta;
        }
        return Object.assign({}, state, {
          newsList: list,
          isGridFetching: false,
          meta,
        });
      }
    case FETCH_NEWS_REQUEST:
    case FETCH_MYDATDBASIC_REQUEST:
    case FETCH_ENROLLMENTLIST_REQUEST:
      {
        return Object.assign({}, state, {
          isFetching: true,
        });
      }
    case FETCH_NEWS_SUCCESS:
      {
        const httpStatusCode = Number(action.response.meta.httpStatusCode);
        let data = {};
        if (httpStatusCode === 200 && action.response.hasOwnProperty('data')) {
          data = action.response.data;
        }
        return Object.assign({}, state, {
          news: data,
        });
      }
    case FETCH_NEWS_FAILURE:
    case FETCH_MYDATDBASIC_FAILURE:
    case FETCH_ENROLLMENTLIST_FAILURE:
      {
        return Object.assign({}, state, {
          error: action.error,
        });
      }
    case FETCH_MYDATDBASIC_SUCCESS:
      {
        const httpStatusCode = Number(action.response.meta.httpStatusCode);
        let data = {};
        if (httpStatusCode === 200 && action.response.hasOwnProperty('data')) {
          data = action.response.data;
        }
        return Object.assign({}, state, {
          myData: data,
        });
      }
    case FETCH_ENROLLMENTLIST_SUCCESS:
      {
        const httpStatusCode = Number(action.response.meta.httpStatusCode);
        let list = [];
        if (httpStatusCode === 200 && action.response.hasOwnProperty('data')) {
          list = action.response.data;
        }
        return Object.assign({}, state, {
          enrollList: list,
        });
      }
    default:
      return state;
  }
}

/* 公司消息分類列表  */
export function fetchNewsCategory() {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}NewsCompany/AnnouncementCategory`,
      method: 'GET',
      types: [
        FETCH_NEWSCATEGORY_REQUEST,
        FETCH_NEWSCATEGORY_SUCCESS,
        FETCH_NEWSCATEGORY_FAILURE,
      ],
    },
  };
}

/* 列表消息查詢 */
export function fetchNewsList(announcementCategoryId, pageNumber) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}NewsCompany/Announcement?AnnouncementCategoryId=${announcementCategoryId}&pageNumber=${pageNumber}`,
      method: 'GET',
      types: [
        FETCH_NEWSLIST_REQUEST,
        FETCH_NEWSLIST_SUCCESS,
        FETCH_NEWSLIST_FAILURE,
      ],
    },
  };
}

/* 消息查詢單筆 */
export function fetchNews(announcementId) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}NewsCompany/Announcement/${announcementId}`,
      method: 'GET',
      types: [
        FETCH_NEWS_REQUEST,
        FETCH_NEWS_SUCCESS,
        FETCH_NEWS_FAILURE,
      ],
    },
  };
}

/* 取得目前報名者資訊 By 登入者 */
export function fetchMyDataBasic() {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}NewsCompany/Enrollment/GetMyDataBasic`,
      method: 'GET',
      types: [
        FETCH_MYDATDBASIC_REQUEST,
        FETCH_MYDATDBASIC_SUCCESS,
        FETCH_MYDATDBASIC_FAILURE,
      ],
    },
  };
}

/* 取得目前報名名單 By 消息ID+登入者 */
export function fetchEnrollmentList(announcementId) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}NewsCompany/Enrollment/?AnnouncementId=${announcementId}`,
      method: 'GET',
      types: [
        FETCH_ENROLLMENTLIST_REQUEST,
        FETCH_ENROLLMENTLIST_SUCCESS,
        FETCH_ENROLLMENTLIST_FAILURE,
      ],
    },
  };
}

/* 報名 */
export function putEnrollmentList(announcementId, data) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}NewsCompany/Enrollment/?AnnouncementId=${announcementId}`,
      method: 'PUT',
      params: data,
      types: [
        PUT_ENROLLMENTLIST_REQUEST,
        PUT_ENROLLMENTLIST_SUCCESS,
        PUT_ENROLLMENTLIST_FAILURE,
      ],
    },
  };
}

/* 取消報名 */
export function deleteEnrollmentList(announcementId) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}NewsCompany/Enrollment/?AnnouncementId=${announcementId}`,
      method: 'DELETE',
      types: [
        DELETE_ENROLLMENTLIST_REQUEST,
        DELETE_ENROLLMENTLIST_SUCCESS,
        DELETE_ENROLLMENTLIST_FAILURE,
      ],
    },
  };
}
/* 下載檔案 */
export function downloadEnrollAttachment(apiUrl) {
  const fetchOptions = {
    mode: 'cors',
    method: 'GET',
    headers: {},
  };
  let downloadUrl = apiUrl.split('api/')[1];
  fetchOptions.headers['Content-Type'] = 'application/json';
  downloadUrl = `${NEWTUBE_API_SERVER}${downloadUrl}`;
  return fetchData(downloadUrl, fetchOptions);
}



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/screens/Tube/screens/CompanyNews/screens/User/reducers/index.js
 **/